import { render, staticRenderFns } from "./SingleTranscriptQueue.vue?vue&type=template&id=b74315f8&"
import script from "./SingleTranscriptQueue.vue?vue&type=script&lang=js&"
export * from "./SingleTranscriptQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports